import ServiceFactory from "utilities/services/service-factory";
import ShareSpaceItemRecord from "models/view-models/share-spaces/share-space-item-record";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

export interface ShareSpaceItemPathParams {
    guid: string;
}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const baseEndpoint = "sharespaces/recipientaccess/:guid/sharespaceitems";
const resourceType = ShareSpaceItemRecord;

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Service
// -------------------------------------------------------------------------------------------------

const RecipientAccessShareSpaceItemService = {
    list: ServiceFactory.nestedList<
        ShareSpaceItemRecord,
        ShareSpaceItemPathParams,
        undefined
    >(resourceType, baseEndpoint),
};

// #endregion Service

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export default RecipientAccessShareSpaceItemService;

// #endregion Exports
